import api from './clients';

type ContratoCuota = any;
type ContratoCuotaFormData = any;

const formatPdfUrl = (rawUrl: string): string => {
  if (!rawUrl) return '';
  if (rawUrl.startsWith('/') || rawUrl.startsWith('./')) {
    const baseApiUrl = import.meta.env.VITE_API_URL || '';
    const backendDomain = baseApiUrl.replace(/\/api$/, '') || window.location.origin;

    let cleanPath = rawUrl;
    if (cleanPath.startsWith('./')) {
      cleanPath = cleanPath.substring(1);
    }
    if (!cleanPath.startsWith('/')) {
      cleanPath = `/${cleanPath}`;
    }

    return `${backendDomain}${cleanPath}`;
  }
  return rawUrl;
};

export const installmentsApi = {
  getAll: async (params?: any): Promise<{ data: ContratoCuota[]; pagination: any }> => {
    const response = await api.get('/installments', { params });
    return response.data;
  },

  getById: async (id: number): Promise<ContratoCuota> => {
    const response = await api.get(`/installments/${id}`);
    const data = response.data?.data || response.data;

    if (data?.pdfUrl) {
      data.pdfUrl = formatPdfUrl(data.pdfUrl);
    }
    if (data?.url) {
      data.url = formatPdfUrl(data.url);
    }
    return data;
  },

  create: async (data: ContratoCuotaFormData): Promise<ContratoCuota> => {
    const response = await api.post('/installments', data);
    return response.data.data;
  },

  update: async (id: number, data: Partial<ContratoCuotaFormData>): Promise<ContratoCuota> => {
    const response = await api.put(`/installments/${id}`, data);
    return response.data.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/installments/${id}`);
  },

  getStats: async (): Promise<any> => {
    const response = await api.get('/installments/estadisticas');
    return response.data.data;
  },

  generatePDF: async (id: number): Promise<{ pdfUrl: string }> => {
    const response = await api.post(`/installments/${id}/pdf`);
    const data = response.data?.data || response.data;
    const rawUrl = typeof data === 'string' ? data : (data?.pdfUrl || data?.url || '');

    return { pdfUrl: formatPdfUrl(rawUrl) };
  },
};